import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import cn from 'classnames';

import { getLocationImage } from './utils/cloudinary';

import styles from './styles.module.css';

class TileImage extends PureComponent {
  render() {
    const { className, text, link, image, onClick, isMobile } = this.props;

    return (
      <Link
        className={cn(styles.tileImage, className)}
        to={link}
        onClick={onClick}
      >
        <img src={getLocationImage(image, isMobile)} alt={text} />
        <div className={styles.tileImageText}>{text}</div>
      </Link>
    );
  }
}

export default TileImage;
